module.exports = __webpack_public_path__ + "img/4.a4ccded8.png";